module.exports = __webpack_public_path__ + "media/images/endia_logo_600x-b08abdec2890811fe9446a2db3e512a4.png";